import { useEffect, useState, useRef } from 'react';
import { nanoid } from 'nanoid';
import { useSpacePublicZustandStore } from '@/helpers/spacepublicprovider';
import SelectRiders from '@/components/core/selectRiders';

function Riders({ capacities }) {
  const datesSelected = useSpacePublicZustandStore((state) => state.datesSelected);
  const getMinPerson = () => 1;
  const listboxRef = useRef(null);

  const [state, setState] = useState({
    valueSelected: useSpacePublicZustandStore.getState().riders || getMinPerson(),
  });

  const getMaxCapacities = () => {
    const max = Math.max(...Object.values(capacities || { default: 1 }));
    const options = [];
    for (let i = getMinPerson(); i <= max; i += 1) {
      options.push({
        value: i,
        title: <div>{i} pers.</div>,
      });
    }
    return options;
  };
  const onSelected = (sel) => {
    state.valueSelected = sel.value;
    setState({ ...state });
  };

  useEffect(() => {
    if (!Object.keys(datesSelected).length) useSpacePublicZustandStore.setState({ riders: 0 });
    else if (useSpacePublicZustandStore.getState().riders === 0) {
      useSpacePublicZustandStore.setState({ riders: getMinPerson() });
    }
  }, [datesSelected]);

  useEffect(() => {
    state.valueSelected = 1;
    setState({ ...state });
  }, [datesSelected]);

  useEffect(() => {
    if (state.valueSelected && Object.keys(datesSelected).length) {
      useSpacePublicZustandStore.setState({ riders: state.valueSelected });
    }
  }, [state.valueSelected]);

  return (
    <SelectRiders
      ref={listboxRef}
      valueDefault={state.valueSelected}
      options={getMaxCapacities()}
      onSelected={onSelected}
    />
  );
}

export default Riders;
